import { cn } from "@/utils/theme";
import {
  Avatar,
  AvatarFallback,
  Badge,
  Icon,
} from "@elaniintc/goes-design-system";
import { Renderify } from "renderify-js";
import type { ClassNameValue } from "tailwind-merge";

interface UserLogRowProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  isOwner?: boolean;
  roleName?: string;
  action: string;
  reason?: string;
  className?: ClassNameValue;
}

export const AssociateLogRow = ({
  email,
  firstName,
  lastName,
  isOwner,
  roleName,
  action,
  reason,
  className,
}: UserLogRowProps) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <div className="flex items-center gap-2">
        <span className="text-body-loud">Usuario</span>
        <div className="flex items-center gap-1">
          <Avatar size={"sm"}>
            <AvatarFallback color="action">
              {firstName?.charAt(0).toUpperCase() ||
                email?.charAt(0).toUpperCase() ||
                "U"}
            </AvatarFallback>
          </Avatar>
          <p className="text-action">{fullName || email}</p>
        </div>
        <Renderify
          condition={[
            "users_linked",
            "associate_added",
            "owners_linked",
            "created",
          ].includes(action)}
          elseShow={
            <Renderify
              condition={action === "associate_updated"}
              elseShow={null}
            >
              <>
                <span className="text-body-loud">se actualizó el rol a</span>
                <Badge size="sm" variant={isOwner ? "success" : "neutral"}>
                  {isOwner ? "Propietario" : roleName || "Sin rol"}
                </Badge>
              </>
            </Renderify>
          }
        >
          <>
            <span className="text-body-loud">se asignó el rol</span>
            <Badge size="sm" variant={isOwner ? "success" : "neutral"}>
              {isOwner ? "Propietario" : roleName || "Sin rol"}
            </Badge>
          </>
        </Renderify>
      </div>
      <Renderify condition={!!reason}>
        <div>
          <Badge size="sm" variant="warning">
            <Icon type="far" name="warning" size="xs" />
            {reason}
          </Badge>
        </div>
      </Renderify>
    </div>
  );
};
